import { render, staticRenderFns } from "./plc-simulator-dialog.vue?vue&type=template&id=608ba962&scoped=true"
import script from "./plc-simulator-dialog.vue?vue&type=script&lang=js"
export * from "./plc-simulator-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ba962",
  null
  
)

export default component.exports